import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { buildStoreConfig } from '../storeAliasHelper';

export const SleepMaskShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 3290,
        variantId: '40946872746054',
        shopifyVariantId: 'gid://shopify/ProductVariant/40946872746054',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/40946872746054:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 39,
        variantId: '40911838183484',
        shopifyVariantId: 'gid://shopify/ProductVariant/40911838183484',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40911838183484:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 39,
        variantId: '40200381038688',
        shopifyVariantId: 'gid://shopify/ProductVariant/40200381038688',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40200381038688:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 150,
        variantId: '45034593812722',
        shopifyVariantId: 'gid://shopify/ProductVariant/45034593812722',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45034593812722:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 35,
        variantId: '49202074190142',
        shopifyVariantId: 'gid://shopify/ProductVariant/49202074190142',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49202074190142:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 29,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 49,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 69,
        // CA inherits variant details from US
      },
      [ShopifyStore.ZA]: {
        price: 999,
      },
      [ShopifyStore.JP]: {
        price: 4980,
      },
    })
  : buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 3290,
        variantId: '40858426769481',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858426769481',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/40858426769481:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 39,
        variantId: '40858426769481',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858426769481',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/40858426769481:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 39,
        variantId: '40858426769481',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858426769481',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40858426769481:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 150,
        variantId: '40858426769481',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858426769481',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40858426769481:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 35,
        variantId: '40858426769481',
        shopifyVariantId: 'gid://shopify/ProductVariant/40858426769481',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/40858426769481:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 29,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 49,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 69,
        // CA inherits variant details from US
      },
      [ShopifyStore.ZA]: {
        price: 999,
      },
      [ShopifyStore.JP]: {
        price: 4980,
      },
    });
